import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import CtaButton from '../../ctaButton/ctaButton';
import trackHeapEvent from '../../../services/helpers/trackHeapEvent';
import styles from './tabItemsContent.module.scss';

function TabItemsContent({ content, cta, tokenKey }) {
  const [isCtaVisible, setCtaVisible] = useState(false);

  useEffect(() => {
    if (!cta) {
      setCtaVisible(false);
    } else {
      setCtaVisible(true);
    }
  }, [cta]);

  const tabHeapTrack = (heapEventKey) => {
    const key = heapEventKey
      ? `${heapEventKey}`
      : `${content.contentTitle.replace(' ', '_')}`;
    trackHeapEvent(
      {
        Name: 'Tab Module',
        CTA: key,
        Title: document.title,
      },
      'CMS_Unification'
    );
  };

  return (
    <div className={styles.panelContentWrapper}>
      <div className={styles.panelContent}>
        <div className={styles.panelText}>
          <h2 className={styles.tabContentTitle}>{content.contentTitle}</h2>
          {parse(content.contentBody)}
        </div>
        <div className={styles.tabCtaContainer}>
          {isCtaVisible ? (
            <CtaButton
              variant={cta?.variant}
              color={cta?.color}
              label={cta?.label}
              className={styles.tabCta}
              href={cta?.link}
              onClick={() => tabHeapTrack(tokenKey)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

TabItemsContent.propTypes = {
  content: PropTypes.any.isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
  }),
  tokenKey: PropTypes.string,
};

export default TabItemsContent;
